import React from 'react';
import { assets, business } from '../data/content';
import { SectionLabel } from './SectionLabel';
export function About() {
  return <section id="about" aria-labelledby="about-heading" className="w-full bg-warm py-20 lg:py-28" data-id="element-1" data-mp="2ps0e4dok8pn2">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-2" data-mp="2triqgl2bfsea">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-12" data-id="element-3" data-mp="2ysojkjzw1hoc">
          <div className="lg:col-span-6" data-id="element-4" data-mp="33r9kymqvm7ed">
            <SectionLabel number="04" data-id="element-5" data-mp="33q6wsmkxuj25">About</SectionLabel>
            <h2 id="about-heading" className="mt-5 font-display text-[34px] font-semibold uppercase leading-[1.02] text-ink sm:text-[44px] lg:text-[50px]" data-id="element-6" data-mp="38qcpm62y2blt">
              South Lyon roots. A regional utility focus.
            </h2>
            <div className="mt-6 max-w-2xl space-y-4 text-base leading-relaxed text-steel sm:text-lg" data-id="element-7" data-mp="3hhv8ior9z5il">
              <p data-id="element-8" data-mp="3mfmxb9wmibik">
                South Lyon Fence has served Southeastern Michigan since {business.since}. We are
                based at {business.address.street} in {business.address.city},{' '}
                {business.address.state} {business.address.zip}.
              </p>
              <p data-id="element-9" data-mp="2gqkwet8nvks5">
                Today, we provide fencing, gates and specialty perimeter protection for utility
                companies and commercial contractors across Michigan, Indiana and Ohio.
              </p>
            </div>

            <div className="mt-10 border-t border-steel-300 pt-6" data-id="element-10" data-mp="34hp4ztcd25fv">
              <p className="font-display text-[13px] uppercase tracking-[0.24em] text-steel" data-id="element-11" data-mp="34gx9eiirk7pl">
                Service area
              </p>
              <p className="mt-3 flex flex-wrap items-baseline gap-x-4 font-display text-[40px] font-semibold uppercase leading-none text-ink sm:text-[56px]" data-id="element-12" data-mp="2vp55kqo8vwtz">
                <span data-id="element-13" data-mp="2qq20x7c6fsmj">MI</span>
                <span aria-hidden="true" className="text-safety-600" data-id="element-14" data-mp="3o5ft4kl02sww">
                  /
                </span>
                <span data-id="element-15" data-mp="3jefvfd4246tc">IN</span>
                <span aria-hidden="true" className="text-safety-600" data-id="element-16" data-mp="3je7lnu38dhmd">
                  /
                </span>
                <span data-id="element-17" data-mp="66lwo2410ubh">OH</span>
              </p>
              <p className="mt-3 text-sm text-steel" data-id="element-18" data-mp="b4nc8d28ubi7">
                Serving Michigan, Indiana and Ohio from New Hudson, Michigan.
              </p>
            </div>
          </div>

          <div className="lg:col-span-6 lg:self-center" data-id="element-19" data-mp="1f3vpe206tqi">
            <img src={assets.building} alt="South Lyon Fence company building and yard in New Hudson, Michigan" width={1536} height={1024} loading="lazy" decoding="async" className="block h-auto w-full border border-warm-200" data-id="element-20" data-mp="1dkdhhwse8m3" />
            <p className="mt-3 text-sm leading-relaxed text-steel" data-id="element-21" data-mp="3elngf2t0y20o">
              Company location at {business.address.street}, {business.address.city},{' '}
              {business.address.state}.
            </p>
          </div>
        </div>
      </div>
    </section>;
}